import { useAuthContext } from '../contexts/AuthContext';

/**
 * Convenience wrapper around useAuthContext.
 *
 * @returns Auth state and methods (user, signIn, signOut, etc.).
 */
export const useAuth = () => {
  return useAuthContext();
};

export default useAuth;
